import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import { hocSinhApi } from "../../../api/hocSinhApi"
import { IHocSinhSelectRequest } from "../../../models/request/hoc-sinh/IHocSinhSelectRequest"
import { IBaseResponeModel } from "../../../models/response/base-response"
import { eChieuCaoCanNangActionTypeIds, IChieuCaoCanNangActionTypes } from "../../action-types/dan-thuoc/IChieuCaoCanNangActionTypes"
import { actions } from "../../actions/actionsWrapper"
import { chieuCaoCanNangApi } from "../../../api/chieuCaoCanNangApi"
import { IChieuCaoCanNangSelectByLopRequest } from "../../../models/request/dan-thuoc/IChieuCaoCanNangSelectByLopRequest"
import { IChieuCaoCanNang } from "../../../models/response/dan-thuoc/IChieuCaoCanNang"
import { IIdsRequest } from "../../../models/request/base/IIdsRequest"


export function* chieuCaoCanNangSaga(): any {
    yield takeLatest(eChieuCaoCanNangActionTypeIds.LOAD_HOC_SINH_START, loadHocSinhWorker)
    yield takeLatest(eChieuCaoCanNangActionTypeIds.LOAD_KETQUA_START, loadKetQuaWorker)
    yield takeEvery(eChieuCaoCanNangActionTypeIds.SAVE_START, saveKetQuaWorker)
    yield takeEvery(eChieuCaoCanNangActionTypeIds.DELETE_START, deleteKetQuaWorker)
    yield takeEvery(eChieuCaoCanNangActionTypeIds.SEND_NOTIFY_START, sendNotifyWorker)

}

function* loadHocSinhWorker(action: IChieuCaoCanNangActionTypes): any {
    const res: IBaseResponeModel = yield call([hocSinhApi, hocSinhApi.Select], action.payload as IHocSinhSelectRequest)
    if (res.is_success) {
        yield put(actions.danThuoc.chieuCaoCanNangActionts.LOAD_HOC_SINH_SUCCESS(res.data))
    } else {
        yield put(actions.danThuoc.chieuCaoCanNangActionts.LOAD_HOC_SINH_ERROR(res.message ?? ""))
    }
}

function* loadKetQuaWorker(action: IChieuCaoCanNangActionTypes): any {
    const res: IBaseResponeModel = yield call(chieuCaoCanNangApi.selectByLop, action.payload as IChieuCaoCanNangSelectByLopRequest)
    if (res.is_success) {
        yield put(actions.danThuoc.chieuCaoCanNangActionts.LOAD_KETQUA_SUCCESS(res.data))
    } else {
        yield put(actions.danThuoc.chieuCaoCanNangActionts.LOAD_KETQUA_ERROR(res.message ?? ""))
    }
}

function* saveKetQuaWorker(action: IChieuCaoCanNangActionTypes): any {
    const res: IBaseResponeModel = yield call(chieuCaoCanNangApi.save, action.payload as IChieuCaoCanNang)
    if (res.is_success) {
        yield put(actions.danThuoc.chieuCaoCanNangActionts.SAVE_SUCCESS(res.data))
    } else {
        yield put(actions.danThuoc.chieuCaoCanNangActionts.SAVE_ERROR(res.message ?? ""))
    }
}

function* deleteKetQuaWorker(action: IChieuCaoCanNangActionTypes): any {
    const res: IBaseResponeModel = yield call(chieuCaoCanNangApi.delete, action.payload as number)
    if (res.is_success) {
        yield put(actions.danThuoc.chieuCaoCanNangActionts.DELETE_SUCCESS(res.data))
    } else {
        yield put(actions.danThuoc.chieuCaoCanNangActionts.DELETE_ERROR(res.message ?? ""))
    }
}

function* sendNotifyWorker(action: IChieuCaoCanNangActionTypes): any {
    const res: IBaseResponeModel = yield call(chieuCaoCanNangApi.sendNotifyAsync, action.payload as IIdsRequest)
    if (res.is_success) {
        yield put(actions.danThuoc.chieuCaoCanNangActionts.SEND_NOTIFY_SUCCESS(res.data))
    } else {
        yield put(actions.danThuoc.chieuCaoCanNangActionts.SEND_NOTIFY_ERROR(res.message ?? ""))
    }
}
